import { X, CheckCircle, AlertCircle, Info } from 'lucide-react';
import { useNotification } from '../../contexts/NotificationContext';

const STYLES = {
  success: {
    container: 'bg-green-950/95 border-green-700/60',
    text: 'text-green-200',
    icon: <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />,
    action: 'text-green-300 hover:text-green-100',
  },
  error: {
    container: 'bg-red-950/95 border-red-700/60',
    text: 'text-red-200',
    icon: <AlertCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" />,
    action: 'text-red-300 hover:text-red-100',
  },
  info: {
    container: 'bg-blue-950/95 border-blue-700/60',
    text: 'text-blue-200',
    icon: <Info className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />,
    action: 'text-blue-300 hover:text-blue-100',
  },
};

function NotificationItem({ notification, onRemove }) {
  const s = STYLES[notification.type] || STYLES.info;

  return (
    <div
      className={`w-full max-w-lg rounded-lg shadow-2xl border px-4 py-3 flex items-start gap-3 backdrop-blur-sm animate-slide-down ${s.container}`}
    >
      {s.icon}
      <div className="flex-1 min-w-0">
        <p className={`text-sm font-medium ${s.text}`}>{notification.message}</p>
        {notification.action && (
          <button
            onClick={() => {
              notification.action.onClick();
              onRemove(notification.id);
            }}
            className={`mt-1.5 text-sm font-semibold underline underline-offset-2 ${s.action}`}
          >
            {notification.action.label}
          </button>
        )}
      </div>
      <button
        onClick={() => onRemove(notification.id)}
        className={`p-1 rounded hover:bg-white/10 flex-shrink-0 ${s.text}`}
        aria-label="Dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}

export default function NotificationBanner() {
  const { notifications, removeNotification } = useNotification();

  if (notifications.length === 0) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] flex flex-col items-center gap-2 pt-4 px-4 pointer-events-none">
      {notifications.map(n => (
        <div key={n.id} className="pointer-events-auto w-full flex justify-center">
          <NotificationItem notification={n} onRemove={removeNotification} />
        </div>
      ))}
    </div>
  );
}
